export default function correctIncorrect() {
    // Helper function to check if element has pre-set opg-blank-notice
    function hasBlankNotice(element) {
        return element.querySelector('.opg-blank-notice') !== null;
    }

    // Get elements with correct-incorrect class names
    const elCorrectIncorrect = document.querySelectorAll(
        '.opg-correct, .opg-incorrect'
    );

    elCorrectIncorrect.forEach((element) => {
        if (!hasBlankNotice(element)) {
            const notice = document.createElement('span');
            notice.className = 'opg-blank-notice sr-only';

            if (element.classList.contains('opg-correct')) {
                notice.textContent = 'Correct. ';
            } else {
                notice.textContent = 'Incorrect. ';
            }

            element.insertBefore(notice, element.firstChild);
        }
    });
}

correctIncorrect();
